module.exports = {"id":"197166","name":"Juan Agudelo","rating":"71","photo":"./data/images/photos/0/197166.png","club":{"name":"New England","logo":"./data/images/clubs/NewEngland.png"},"positions":["BU","AG"],"photoFolderIndex":0}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JuanAgudelo0.json
// module id = 2205
// module chunks = 0